import { atenyaUser, loginTypeConst, LoginTypeConstObj } from 'constant/const'
import React, { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import InSidebar from './InSidebar'
import './instagramLayout.css'

function InstagramLayout() {
   const location = useLocation()

   useEffect(() => {
      window.scrollTo(0, 0)
      return () => {}
   }, [location])

   let loginType = localStorage.getItem(loginTypeConst)
   let user = localStorage.getItem(atenyaUser)

   if (!loginType) {
      if (location.pathname.includes('/instagram')) {
         return <Navigate to={'/instagram/login'} />
      } else {
         return <Navigate to={'/auth/login'} />
      }
   } else if (!user) {
      return <Navigate to={'/auth/login'} />
   } else if (loginType === LoginTypeConstObj.google) {
      return <Navigate to={'/dashboard'} />
   }

   return (
      <div className="template-pages">
         <InSidebar />
         <div className="instagram-content atenya-content ">
            <Outlet />
         </div>
      </div>
   )
}

export default InstagramLayout
